﻿import { use } from 'react';

import { ClientContext } from './ClientContext';

/**
 * Hook for accessing the multi-tenant client context.
 *
 * Must be used inside a `<ClientProvider>`. Exposes:
 *   - clients: all accessible clients
 *   - selectedClient: the currently active client (null while loading)
 *   - isLoading / isError: loading/error state for the client list
 *   - switchClient(clientId): switches active client and persists the selection
 */
export function useClient() {
    const ctx = use(ClientContext);

    if (!ctx) {
        throw new Error('useClient must be used within a <ClientProvider>');
    }

    return ctx;
}
